package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.GENERATE_MERCHANT_VERIFICATION_CODE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

/**
 * Request model for generating a verification code for merchant registration.
 * 
 * Uses the same parameters as CreateMerchantRequestModel to generate
 * a verification code that will be sent to the merchant's email.
 */
@Serializable
data class GenerateMerchantVerificationCodeRequestModel(
    // Company details (for merchants table)
    val companyName: String, // maps to merchants.company_name (will create translation key on server)
    val email: String, // maps to merchants.email
    val password: String, // maps to merchants.password
    val dialCode: String, // maps to merchants.dial_code
    val phoneNumber: String, // maps to merchants.phone_number
    val bulstat: String, // maps to merchants.bulstat
    val iban: String, // maps to merchants.iban
    val countryId: Int, // maps to merchants.country_id
    val cityId: Long, // maps to merchants.city_id
    val privacyPolicyAccepted: Boolean, // maps to merchants.privacy_policy_accepted
    val companyStreet: String? = null, // maps to merchants.company_street (nullable)
    val companyImage: ByteArray? = null, // Company logo/image file
    
    // Company signatory details (for company_responsible_persons table) - list of responsible persons
    val signatories: List<com.example.mystybag.sharedmodels.project.requestModels.merchant.SignatoryItem>
) : BaseRequestModel(api = GENERATE_MERCHANT_VERIFICATION_CODE)

